import ServiceFamilyConfig from "@/model/ServiceFamilyConfig"
import BookingData from "@/classes/BookingData"

import { FunnelConfigObj } from "@requests"

const processFunnelConfig = (bookingData: BookingData) => {
    bookingData.responses.funnelConfig!.forEach((configObj: FunnelConfigObj) => {
        const serviceFamilyConfig = new ServiceFamilyConfig(configObj.embededFamilies, configObj.expanded, configObj.familyId)
        bookingData.funnelConfigArr.push(serviceFamilyConfig)
        bookingData.funnelConfigMap.set(serviceFamilyConfig.getFamilyId(), serviceFamilyConfig)
    })
}

export default processFunnelConfig